import { Body, Button, Divider, Flex, H3 } from '@taxbit-private/cosmic'
import { useState } from 'react'
import styled from 'styled-components'

import { useAuth } from 'contexts/auth/AuthContext'

const NeedsVerification = () => {
  const [sentEmail, setSentEmail] = useState(false)
  const { currentUser, authManager } = useAuth()

  return (
    <ContentWrapper gap="m" direction="column" alignItems="center">
      <H3 as="h1">Check your email</H3>
      <Flex direction="column" gap="m" alignItems="center">
        {sentEmail ? (
          <CenteredBody variant="secondary">
            Verification email sent. Please check your inbox.
          </CenteredBody>
        ) : (
          <>
            <CenteredBody variant="secondary">
              We sent an email containing a link to verify the address {currentUser?.email}.
            </CenteredBody>
            <FixedWidthButton
              onClick={() => {
                if (currentUser && authManager) {
                  void authManager.sendVerificationEmail?.()
                  setSentEmail(true)
                }
              }}
              label="Resend Verification Email"
              trackingId="needs-verification-resend-button"
              variant="button-secondary"
            />
          </>
        )}
        <Divider />
        <Button
          onClick={() => {
            if (authManager) {
              void authManager.signOut()
            }
          }}
          label="Back to login"
          trackingId="needs-verification-logout-button"
          variant="anchor-primary-inline"
        />
      </Flex>
    </ContentWrapper>
  )
}

const ContentWrapper = styled(Flex)(
  ({ theme }) => `
  width: ${theme.measure.m};
`
)

const FixedWidthButton = styled(Button)(
  ({ theme }) => `
  width: ${theme.measure.m}
`
)

const CenteredBody = styled(Body)`
  text-align: center;
`

export default NeedsVerification
